import { IAuthActions } from "../../action-types/auth/IAuthActions";
import {
  eAuthStatus,
  IAuthReducer,
} from "../../reducer-model/auth/IAuthReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { menusSample } from "./menusSample";

const iniState: IAuthReducer = {
  showChangePassModal: false,
};
export const authReducer = (
  state: IAuthReducer = iniState,
  action: IAuthActions
): IAuthReducer => {
  switch (action.type) {
    case "AUTH_GET_USER_INFO_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "AUTH_GET_USER_INFO_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        user: {
          ...action.payload,
          menus: action.payload.menus,
        },
      };
    case "AUTH_GET_USER_INFO_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        user: undefined,
      };
    case "AUTH_GET_USER_INFO_VNPT_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "AUTH_GET_USER_INFO_VNPT_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        user: {
          ...action.payload,
          menus: action.payload.menus,
        },
      };
    case "AUTH_GET_USER_INFO_VNPT_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        user: undefined,
      };
    case "AUTH_LOGIN_START":
      return {
        ...state,
        status: eAuthStatus.is_loging,
      };
    case "AUTH_LOGIN_SUCCESS":
      return {
        ...state,
        status: eAuthStatus.is_login_success,
        user: {
          ...action.payload.profile,
          // menus: action.payload.profile.menus,
        },
      };
    case "AUTH_LOGIN_ERROR":
      return {
        ...state,
        status: eAuthStatus.is_login_error,
        user: undefined,
      };

    case "AUTH_LOGIN_VNPT_START":
      return {
        ...state,
        status: eAuthStatus.is_loging,
      };
    case "AUTH_LOGIN_VNPT_SUCCESS":
      return {
        ...state,
        status: eAuthStatus.is_login_success,
        user: {
          ...action.payload.profile,
          // menus: action.payload.profile.menus,
        },
      };
    case "AUTH_LOGIN_VNPT_ERROR":
      return {
        ...state,
        status: eAuthStatus.is_login_error,
        user: undefined,
      };

    case "AUTH_LOGOUT_START":
      return {
        ...state,
        status: eAuthStatus.is_logout,
        user: undefined,
      };

    case "AUTH_CHANGE_PASS_SHOWHIDE_MODAL":
      return {
        ...state,
        showChangePassModal: action.payload,
      };
    case "AUTH_CHANGE_PASS_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "AUTH_CHANGE_PASS_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        showChangePassModal: false,
      };
    case "AUTH_CHANGE_PASS_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };

    case "AUTH_LOGOUT_SUCCESS":
    case "AUTH_LOGOUT_ERROR":

    default:
      return {
        ...state,
      };
  }
};
